import { render } from "./TrainingsFilter.vue?vue&type=template&id=8eebe2a8"
import script from "./TrainingsFilter.vue?vue&type=script&lang=js"
export * from "./TrainingsFilter.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__